import React from "react";
import { Grid } from "@mui/material";
import FormTextField from "../FormTextField";
import FormSelect from "../FormSelect";
import { useEmiAdminConfig } from "../../../hooks/useEmiAdminConfig";
import {
  BATTERY_IMEI_LENGTH,
  buildBatteryTypeOptions,
} from "../config/emiConfig";

const AssetAllocationStep = ({ data, onChange, showErrors }) => {
  const { data: emiAdminConfig } = useEmiAdminConfig("v2");
  const batteryTypeOptions = buildBatteryTypeOptions(
    emiAdminConfig?.batteryTypes,
  );

  const getError = (field) =>
    showErrors && !String(data[field] || "").trim()
      ? "This field is required"
      : "";

  const batteryImeiError = (() => {
    if (showErrors && !String(data.batteryImei || "").trim()) {
      return "This field is required";
    }
    return "";
  })();

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6}>
        <FormSelect
          label="Battery Type"
          required
          value={data.batteryType}
          onChange={(value) => onChange("batteryType", value)}
          options={batteryTypeOptions}
          error={getError("batteryType")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormTextField
          label="Battery IMEI"
          required
          value={data.batteryImei}
          onChange={(value) => onChange("batteryImei", value)}
          error={batteryImeiError}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormTextField
          label="Charger ID"
          required
          value={data.chargerId}
          onChange={(value) => onChange("chargerId", value)}
          error={getError("chargerId")}
        />
      </Grid>
    </Grid>
  );
};

export default AssetAllocationStep;
